/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        // {
        //   path: "/",
        //   redirect: "/charts/cashregisters"
        // },

        // // =============================================================================
        // // CHARTS LAYOUT ROUTES
        // // =============================================================================
        // {
        //   path: "/charts/cashregisters",
        //   name: "charts-cash-registers",
        //   component: () => import("./views/pages/charts/Cashregisters.vue"),
        //   meta: {
        //     rule: "admin",
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: "/charts/articles",
        //   name: "charts-articles",
        //   component: () => import("./views/pages/charts/Articles.vue"),
        //   meta: {
        //     rule: "admin",
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: "/charts/valuecards",
        //   name: "charts-valuecards",
        //   component: () => import("./views/pages/charts/ValueCards.vue"),
        //   meta: {
        //     rule: "admin",
        //     requiresAuth: true
        //   }
        // },

        {
          path: '/',
          redirect: '/charts/parking/longterm'
        },

        // =============================================================================
        // CHARTS LAYOUT ROUTES
        // =============================================================================
        /*{
          path: "/charts/parking/rent",
          name: "charts-parking-rent",
          component: () => import("./views/pages/charts/ParkingSpaceRent.vue"),
          meta: {
            rule: "admin",
            requiresAuth: true
          }
        },
        {
          path: "/charts/parking/owner",
          name: "charts-parking-owner",
          component: () => import("./views/pages/charts/ParkingSpaceOwner.vue"),
          meta: {
            rule: "admin",
            requiresAuth: true
          }
        },
        {
          path: "/charts/parking/owner/credit",
          name: "charts-office-rent",
          component: () => import("./views/pages/charts/ParkingSpaceOwnerCredit.vue"),
          meta: {
            rule: "admin",
            requiresAuth: true
          }
        },
        {
          path: "/charts/parking/valuecards",
          name: "charts-parking-value-cards",
          component: () => import("./views/pages/charts/ValueCards.vue"),
          meta: {
            rule: "admin",
            requiresAuth: true
          }
        },*/
        {
          path: '/charts/parking/shortterm',
          name: 'charts-parking-shortterm',
          component: () => import('./views/pages/charts/ParkingShortTerm.vue'),
          meta: {
            rule: 'admin',
            requiresAuth: true
          }
        },

        {
          path: '/charts/parking/longterm',
          name: 'charts-parking-longterm',
          component: () => import('./views/pages/charts/ParkingLongTerm.vue'),
          meta: {
            rule: 'admin',
            requiresAuth: true
          }
        },

        {
          path: '/charts/parking/owner',
          name: 'charts-parking-owner',
          component: () => import('./views/pages/charts/ParkingSpaceOwner.vue'),
          meta: {
            rule: 'admin',
            requiresAuth: true
          }
        },
        /*{
          path: "/charts/office/rent",
          name: "charts-office-rent",
          component: () => import("./views/pages/charts/OfficeRent.vue"),
          meta: {
            rule: "admin",
            requiresAuth: true
          }
        },*/

        // =============================================================================
        // FILE ROUTES
        // =============================================================================
        {
          path: '/upload/file',
          name: 'upload-file',
          component: () => import('./views/pages/data/UploadFile.vue'),
          meta: {
            rule: 'admin',
            requiresAuth: true
          }
        },
        {
          path: '/filelist',
          name: 'file-list',
          component: () => import('./views/pages/data/FileList.vue'),
          meta: {
            rule: 'admin',
            requiresAuth: true
          }
        }
      ]
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          },
          pageTitle: 'Avtohiša'
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error',
          name: 'page-error',
          component: () => import('@/views/pages/Error.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// this function runs on every request
// if route has meta atribute requiresAuth: true
// user must be logged in, if he's not, it will redirect him to /pages/login
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // meta is field in router element, where you can define user role
    // and if auth is neccesary
    if (to.meta.requiresAuth) {
      if (!auth.isAuthenticated()) {
        router.push({path: '/pages/login'})
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
